import { Dictionary } from 'vue-router/types/router';
import { toOptions } from './ArrayUtil';

export const basicStrengthData: string[] = ['S01Initiatives', 'S02ForceToWork', 'S03Execution', 'S04DiscoverIssues', 'S05Planning', 'S06Creativity'];
export const basicStrengthDataAll: string[] = [
  'S01Initiatives',
  'S02ForceToWork',
  'S03Execution',
  'S04DiscoverIssues',
  'S05Planning',
  'S06Creativity',
  'S07Outgoing',
  'S08Listening',
  'S09Flexibility',
  'S10GraspTheSituation',
  'S11Discipline',
  'S12StressControl',
];
export const basicStrengthTitle: Dictionary<string> = {
  S01Initiatives: '主体性',
  S02ForceToWork: '働きかけ力',
  S03Execution: '実行力',
  S04DiscoverIssues: '課題発見力',
  S05Planning: '計画力',
  S06Creativity: '創造力',
  S07Outgoing: '発信力',
  S08Listening: '傾聴力',
  S09Flexibility: '柔軟性',
  S10GraspTheSituation: '状況把握力',
  S11Discipline: '規律性',
  S12StressControl: 'ストレスコントロール力',
};

export function getItemKeyList(item: string) {
  if (!basicStrengthDataAll.find((d) => d === item)) {
    throw new Error(`${item}は、範囲外です。[${basicStrengthDataAll.join(',')}]`);
  }
  return Object.keys(basicStrengthAllData).filter((k) => k.indexOf(item) > -1);
}

export function getItemOptionsByName(itemName: string) {
  if (!Object.keys(basicStrengthTitle).find((k) => basicStrengthTitle[k] === itemName)) {
    throw new Error(
      `${itemName}は、範囲外です。[${Object.keys(basicStrengthTitle)
        .map((k) => basicStrengthTitle[k])
        .join(',')}]`
    );
  }
  const found = Object.entries(basicStrengthTitle).find((e) => e[1] === itemName);
  if (!found) {
    throw new Error(`${itemName}が見つかりませんでした`);
  }
  return getItemOptions(found[0]);
}

export function getItemOptions(item: string) {
  const list = getItemKeyList(item);
  return list.map((k) => {
    const levelNum = k.replace(item, '');
    return { title: `${levelNum} : ${basicStrengthAllData[k]}`, value: levelNum };
  });
}
export function getBasicStrengthLevelTitle(item: string, level: number) {
  return basicStrengthAllData[`${item}${level}`];
}
export const basicStrengthTeamData: string[] = [];
export const basicStrengthAllData: Dictionary<string> = {
  S01Initiatives8: '自分のやりたいことを探求する',
  S02ForceToWork8: '周囲が手伝いたいと感じている',
  S03Execution8: '習慣化している',
  S04DiscoverIssues8: '自らの課題を他の課題と結びつけられる',
  S05Planning8: 'バランスの高い計画を立てられる',
  S06Creativity8: '企画ができる',
  S07Outgoing8: '応援されている',
  S08Listening8: '他者に気づきを与える質問ができる',
  S09Flexibility8: '自分と他者の相乗効果を見つける',
  S10GraspTheSituation8: '周囲のやる気を引き出しながら前に進める',
  S11Discipline8: '適切なルールを作る',
  S12StressControl8: 'ストレスを成長のきっかけにする',
  S01Initiatives7: '自らが楽しい設定ができる',
  S02ForceToWork7: '周囲が関わりたいと感じている',
  S03Execution7: '意味があることを理解して行動している',
  S04DiscoverIssues7: '課題を他者と共有できる',
  S05Planning7: 'バランスの取れた計画を立てる',
  S06Creativity7: '新しい方法を共有する',
  S07Outgoing7: '共感されている',
  S08Listening7: '話しやすい雰囲気を作り情報を引き出す',
  S09Flexibility7: '自分と他者の役割分担を見つける',
  S10GraspTheSituation7: '人間関係を調整し、物事を前に進める',
  S11Discipline7: 'ルールを改善する',
  S12StressControl7: 'ストレスを前向きに捉える',
  S01Initiatives6: '目的に合ったものを自ら作る',
  S02ForceToWork6: '相手のメリットを伝えられる',
  S03Execution6: '評価対象から外れてもできる',
  S04DiscoverIssues6: '現状から理想を考えられる',
  S05Planning6: '時間を守れる計画を立てる',
  S06Creativity6: '新しい方法を試す',
  S07Outgoing6: '相手に合わせた説明方法をいくつも持っている',
  S08Listening6: '相手に気持ちよく話してもらえる',
  S09Flexibility6: '自分と他者の意見の妥協点を見つける',
  S10GraspTheSituation6: '方針を考えることができる',
  S11Discipline6: 'ルールにない組織を守る行動をする',
  S12StressControl6: '改善のための行動を起こす',
  S01Initiatives5: '自ら選ぶ',
  S02ForceToWork5: '貸し借りを成立できる',
  S03Execution5: '言われなくてもできる',
  S04DiscoverIssues5: '理想を自分の言葉で説明できる',
  S05Planning5: '質を問わず計画を立てる',
  S06Creativity5: '既にある方法を改善する',
  S07Outgoing5: '相手の反応を確認して対応している',
  S08Listening5: '自分の理解を深める質問ができる',
  S09Flexibility5: '相手を否定せず自分の意見を言える',
  S10GraspTheSituation5: '周囲の状況を踏まえ、適切な言動ができる',
  S11Discipline5: 'ルールの意図を説明できる',
  S12StressControl5: '自分がどのように行動すれば良いか考える',
  S01Initiatives4: '促されて選ぶ',
  S02ForceToWork4: '多少強引でも自分でお願いする',
  S03Execution4: '促されて自分でできる',
  S04DiscoverIssues4: '促されて理想を持つ',
  S05Planning4: '計画が必要だと分かる',
  S06Creativity4: '自ら方法を真似する',
  S07Outgoing4: '伝える内容や方法を考えて伝える',
  S08Listening4: '会話にズレた感覚がなくなる',
  S09Flexibility4: '他者のペースに合わせることができる',
  S10GraspTheSituation4: '理解の漏れを確認する習慣がついている',
  S11Discipline4: '他者のルール違反を指摘できる',
  S12StressControl4: '客観的な意見を取り入れる',
  S01Initiatives3: '促されて受け入れる',
  S02ForceToWork3: '促されてお願いする',
  S03Execution3: '見守ってもらえれば自分でできる',
  S04DiscoverIssues3: '自分の置かれている状況を他者に説明できる',
  S05Planning3: 'できていない部分に気づく',
  S06Creativity3: '方法を取り入れて行動できる',
  S07Outgoing3: '同じ内容を繰り返し伝える',
  S08Listening3: '相づちがうてる',
  S09Flexibility3: '促されて他者の意見を取り入れて行動する',
  S10GraspTheSituation3: '理解の漏れを促されて確認する',
  S11Discipline3: '自らルールを守る',
  S12StressControl3: '自ら相談できる',
  S01Initiatives2: '説得されて受け入れる',
  S02ForceToWork2: '周囲から支援してもらう',
  S03Execution2: '細かく指示すればできる',
  S04DiscoverIssues2: '自分の気持ちを他者に説明できる',
  S05Planning2: '自ら好きなことから手を付ける',
  S06Creativity2: '方法が理解できる',
  S07Outgoing2: '相手の都合はお構いなしに要求を伝える',
  S08Listening2: '人の話を最後まで聞く',
  S09Flexibility2: '促されて他者の意見を否定しない',
  S10GraspTheSituation2: '助けを借りながら状況を読み取る',
  S11Discipline2: '促されてルールを守る',
  S12StressControl2: '促されて話を聞いてもらう',
  S01Initiatives1: '説得に時間がかかる',
  S02ForceToWork1: '一人でやろうとする',
  S03Execution1: '手取り足取りやればできる',
  S04DiscoverIssues1: '自己紹介ができる',
  S05Planning1: '促されて好きなことから手を付ける',
  S06Creativity1: '方法に関心を持つ',
  S07Outgoing1: '促されると発信する',
  S08Listening1: '指摘されて人の話を最後まで聞く',
  S09Flexibility1: '促されて他者の意見を聞く',
  S10GraspTheSituation1: '周囲の状況を読み取ろうとする',
  S11Discipline1: '促されてルールを知る',
  S12StressControl1: '不快感を表現できる',
  S01Initiatives0: '促しても反応がない',
  S02ForceToWork0: '人と関わって何かをやることを嫌がる',
  S03Execution0: 'その場から去る',
  S04DiscoverIssues0: '理想がない',
  S05Planning0: '何から始めたらいいかわからない',
  S06Creativity0: '方法に関心がない',
  S07Outgoing0: '発信しない',
  S08Listening0: '話を聞かない',
  S09Flexibility0: '感情的になる',
  S10GraspTheSituation0: '孤立する',
  S11Discipline0: 'ルールを守らない',
  S12StressControl0: '発生源が何か分からない',
};
